import { Badge } from '../../components/ui.jsx';

export const STATUS_LABELS = { open: 'Open', in_progress: 'In progress', resolved: 'Resolved', closed: 'Closed' };
// Closed is finished, not good news: neutral rather than the panel's usual green.
const TONES = { open: 'warning', in_progress: 'info', resolved: 'success', closed: 'neutral' };

export const CATEGORY_LABELS = {
  account: 'Account',
  credits_payments: 'Credits & payments',
  listing: 'Listings',
  leads_enquiries: 'Leads & enquiries',
  verification: 'Verification',
  bug: 'Something is broken',
  suggestion: 'Suggestion',
  other: 'Other',
};

export const KIND_LABELS = { customer: 'Tenant / owner app', broker: 'Broker app' };

export function StatusBadge({ status }) {
  return <Badge tone={TONES[status] || 'neutral'} label={STATUS_LABELS[status] || status} />;
}
